import {
  Stack,
  IconButton,
  Typography,
  LinearProgress,
  Box,
} from '@mui/material';
import { Close, FilePresentOutlined } from '@mui/icons-material';

interface UploadedFileProps {
  file: File;
  isUploading: boolean;
  uploaded: boolean;
  error: string | undefined;
  onClear?: () => void;
}

const getReadableFileSize = (fileSize: number) => {
  if (!fileSize) return '0 Bytes';
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const power = Math.floor(Math.log(fileSize) / Math.log(1024)); // log base 1024 of fileSize
  return `${(fileSize / 1024 ** power).toFixed(2)} ${units[power]}`;
};

const UploadedFile = ({
  file,
  isUploading,
  uploaded,
  error,
  onClear,
}: UploadedFileProps) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    width="100%"
    sx={{
      borderRadius: 2.5,
      background: 'sky.main',
      px: 2,
      py: 1.5,
      my: 1,
    }}
  >
    <Stack direction="row" flexGrow={1}>
      <FilePresentOutlined sx={{ m: 0.5, mr: 1 }} />
      {/* <Box
        component="img"
        src={URL.createObjectURL(file)}
        maxWidth={50}
        maxHeight={50}
        m={0.5}
        mr={1}
      /> */}
      <Stack flexGrow={1}>
        <Typography variant="body2">{file.name}</Typography>

        {!uploaded && !isUploading && (
          <LinearProgress variant="determinate" value={0} />
        )}
        {isUploading && <LinearProgress />}
        {error && (
          <LinearProgress color="error" variant="determinate" value={100} />
        )}
        {uploaded && <LinearProgress variant="determinate" value={100} />}
        <Stack direction="row" justifyContent="space-between">
          {!uploaded && !isUploading && (
            <Typography variant="body2">Ready to upload</Typography>
          )}
          {isUploading && <Typography variant="body2">Uploading...</Typography>}
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
          {uploaded && <Typography variant="body2">100%</Typography>}
          <Typography variant="body2">
            {getReadableFileSize(file.size)}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
    {onClear ? (
      <IconButton
        onClick={onClear}
        sx={{ position: 'relative', bottom: 20, left: 8 }}
      >
        <Close />
      </IconButton>
    ) : null}
  </Stack>
);

export default UploadedFile;
